export default __webpack_public_path__ + "static/chart_scientific_literacy-689c2a7a9caa6c3d0c1ef7c39378ab0c.svg";